import { render, staticRenderFns } from "./LoginError.vue?vue&type=template&id=52a5c2eb&"
import script from "./LoginError.vue?vue&type=script&lang=ts&"
export * from "./LoginError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports